import React from 'react'
import './sharedLegacy/style/style.scss'
import 'antd/lib/notification/style/css'

import Router from './routes/Router'

import './App.scss'

const App = () => {
  return (
    <div className="admin-root">
      <Router />
    </div>
  )
}

export default App
